class TicketTypeSessionOverrideModalController extends AbstractController
	@register()

	@inject '$uibModalInstance',
		'$q'
		'sessions'

	save: ->
		overrides = []

		for session in @sessions
			if session.session_overrides[0]?
				override = session.session_overrides[0]
				override.ticket_event_session_id = session.id

				overrides.push(override)

		@$uibModalInstance.close(overrides)

	close: ->
		@$uibModalInstance.dismiss(false)
